export default function ($rootScope, $scope, $stateParams, $http, $cookies, $state, $q, CONFIG) {
    'ngInject';

    let contentType = $stateParams.contentType;
    let idParent = $stateParams.idParent;
    let idNavigation = $stateParams.idNavigation;
    let contentTypeId = contentType.sys.id;
    if (!$cookies.get('region')) {
        $cookies.put('region', JSON.stringify($rootScope.regions[0]));
    }
    let region = JSON.parse($cookies.get('region'));


    let formControls = contentType.fields;  // Page
    let endpoint = `entries?limit=1000&content_type=${contentTypeId}&include=5&order=fields.${contentType.displayField}&sys.type[ne]=${(new Date()).valueOf()}`;
    endpoint += `&fields.region.sys.id=${region.sys.id}`;

    let T = $scope.$root.T;

    let contentTypeName = contentType.name;
    let labelSingle = contentTypeName;
    let labelPlural = contentTypeName;
    $scope.labelSingle = labelSingle;
    $scope.labelPlural = labelPlural;
    $scope.isProgress = true;
    $scope.found = false;
    $scope.navTitle = $stateParams.navTitle;
    $scope.idNavigation = idNavigation;
    $rootScope.$broadcast('selectionMenu', {context: 'page'});

    let config = {
        errorMessage: T.HTTP_GET_ERROR_NOTIFICATION + labelPlural
    };

    let apiURL = `${CONFIG.customUploadUrl}contentful/${endpoint}`;

    console.log(apiURL);
    /**
     * Get all pages and found the navigation Item connected to it
     */
    $http.get(apiURL, config).then((data) => {
        $scope.isProgress = false;
        let pages = data.data.items;
        let pageFound = null;


        _.forEach(pages, (page) => {
            if (!!page.fields.navigationItem) {
                if (page.fields.navigationItem.sys.id === idParent) {
                    $scope.found = true;
                    pageFound = page;
                }
            }
        });

        //$http.get(`${CONFIG.customUploadUrl}contentful/entries?content_type=navigation&fields.region.sys.id=${region.sys.id}&sys.type[ne]=${(new Date()).valueOf()}`).then((data) => {

           /* let items = data.data.items[0].fields.navigationItems;

            _.forEach(pages, (page) => {
                _.forEach(items, (item) => {
                    if (!!page.fields.navigationItem) {
                        if (page.fields.navigationItem.sys.id === item.sys.id) {
                            $scope.found = true;
                            pageFound = page;
                        }
                    }
                });
            }); */

            if (pages.length > 0) {
                if (!$scope.found && !!!idParent) {
                    $scope.found = true;
                    pageFound = pages[0];
                    $rootScope.$broadcast('setRemoteNavigationBottom', {selectedNav: pageFound.fields.navigationItem.sys.id});
                }

                if ($scope.found) {
                    let pageId = pageFound.sys.id;
                    let navigationItemId = pageFound.fields.navigationItem.sys.id;

                    $http.get(`${CONFIG.customUploadUrl}contentful/entries?sys.id=${navigationItemId}&sys.type[ne]=${(new Date()).valueOf()}`).then((data) => {
                        let _data = data.data;
                        if (_data.items.length > 0) {
                            let isLink = _data.items[0].fields.hasOwnProperty('url') && !!_data.items[0].fields.url;

                            if (isLink) {
                                let url = _data.items[0].fields.url;
                                let typeLink = url.indexOf('Search') > -1 ? 'search' : url.indexOf('File') > -1 ? 'file' : 'link';
                                $state.go('^.navigationitem', {
                                    id: navigationItemId,
                                    type: typeLink
                                });

                            } else {
                                if (pageFound.fields.hasOwnProperty('articles')) {
                                    let articleId = null;
                                    let isAdmin = $rootScope.firebaseUser.isAdmin;

                                    if (isAdmin) {
                                        articleId = pageFound.fields.articles[0].sys.id;
                                    } else {
                                        _.forEach(pageFound.fields.articles, (article) => {
                                            $http.get(`${CONFIG.customUploadUrl}contentful/entries?content_type=article&fields.region.sys.id=${region.sys.id}&sys.id=${article.sys.id}&sys.type[ne]=${(new Date()).valueOf()}`).then((data) => {
                                                let total = data.data.total;
                                                if (total > 0) {
                                                    articleId = pageFound.fields.articles[0].sys.id;
                                                }
                                            });
                                        });
                                    }

                                    if (articleId === null) {
                                        $state.go('^.add', {
                                            id: pageId,
                                            navigationItemId: navigationItemId
                                        });
                                    } else {
                                        $state.go('^.edit', {
                                            id: pageId,
                                            idChild: articleId,
                                            navigationItemId: navigationItemId
                                        });
                                    }
                                } else {
                                    $state.go('^.add', {
                                        id: pageId,
                                        navigationItemId: navigationItemId
                                    });
                                }
                            }
                        } else {
                            $scope.found = false;
                        }
                    });
                } else {
                    $rootScope.$broadcast('resetNavigationBottom');
                    $rootScope.selectedNav = null;
                }
            } else {
                $scope.isProgress = false;
            }
        //});
    });


    /***
     * Getting Data for Post Call
     * @param idNavigationItem
     * @returns {{}}
     */
    let dataToPost = (idNavigationItem = null) => {
        let result = {};
        let _region = JSON.parse($cookies.get('region'));
        formControls.forEach((control) => {
            let id = control.id;

            result[id] = null;

            result['title'] = 'Unbenannt';

            // NavigationItem
            if (control.type === 'Link' && control.linkType === 'Entry') {
                result[id] = {
                    sys: {
                        type: 'Link',
                        linkType: 'Entry',
                        id: idNavigationItem
                    }
                };
            }

            result['region'] =  {
                sys: {
                    'id': _region.sys.id,
                    'type': 'Link',
                    'linkType': 'Entry'
                }
            };
        });

        return result;
    };

    /***
     * Create Page
     */
    $scope.createPage = () => {
        let config = {
            errorMessage: T.HTTP_POST_ERROR_NOTIFICATION,
            headers: {
                'X-Contentful-Content-Type': contentTypeId
            }
        };

        $scope.isProgress = true;

        $q.all(dataToPost(idNavigation)).then((data) => {
            let dataToPost = _.mapValues(data, (value) => {
                return {
                    en: value
                };
            });

            return $http.post(`${CONFIG.cmApiUrl}entries?sys.type[ne]=${(new Date()).valueOf()}`, {fields: dataToPost}, config).then( (data) => {
                let sys = data.data.sys;

                let config = {
                    successMessage: `Page${T.HTTP_POST_SUCCESS_NOTIFICATION}`,
                    errorMessage: `${T.HTTP_POST_ERROR_NOTIFICATION}Page`,
                    headers: {
                        'X-Contentful-Version': sys.version
                    }
                };

                return $http.put(`${CONFIG.cmApiUrl}entries/${sys.id}/published?sys.type[ne]=${(new Date()).valueOf()}`, null, config).then(() => {
                    $state.reload();
                }, () => {
                    return $http.delete(`${CONFIG.cmApiUrl}entries/${sys.id}?sys.type[ne]=${(new Date()).valueOf()}`);
                });
            });
        });
    };
}



// WEBPACK FOOTER //
// ./src/app/views/app.page/appPagesListCtrl.js